import { CollectiblesManager } from '@/components/collectibles/CollectiblesManager';
import { useTemplateContext } from '@/pages/templates/useTemplateContext';
import { Skeleton } from '@startupquickstart/frontend';

/**
 * Template Collectibles tab — thin wrapper around the shared owner-scoped
 * CollectiblesManager. Templates have no lifecycle, so structure is always
 * editable.
 */
export function TemplateCollectiblesTab() {
  const { template, isLoading } = useTemplateContext();

  if (isLoading || !template) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-32 rounded-xl" />
        <Skeleton className="h-32 rounded-xl" />
      </div>
    );
  }

  return (
    <CollectiblesManager
      ownerId={template.id}
      apiBase={`/templates/${template.id}`}
      keyPrefix="Template"
      structureEditable
    />
  );
}
